(() => {
  const CARD = '[data-sz-boot-only-staged]';

  const forceBootOnlyVariantState = (card) => {
    const node = card.querySelector('[data-sz-skate-variants]');
    if (!node) return;

    try {
      const variants = JSON.parse(node.textContent || '[]');
      if (!Array.isArray(variants)) return;

      node.textContent = JSON.stringify(
        variants.map((variant) => {
          const price = Number(variant?.price || 0);
          const compareAt = Number(variant?.compare_at_price || 0);
          return {
            ...variant,
            compare_at_price: compareAt > price ? compareAt : price + 1,
          };
        })
      );
    } catch (error) {
      console.error('SportsZone boot-only steel state error', error);
    }
  };

  const findMainProduct = () =>
    document.querySelector('product-info[id^="MainProduct"], product-info');

  const mount = (card) => {
    if (!card || card.dataset.szBootOnlyMounted === 'true') return;
    const root = findMainProduct();
    if (!root) return;

    forceBootOnlyVariantState(card);
    card.dataset.szSaleState = 'true';
    card.classList.add('is-boot-only-sale');
    root.classList.add('sz-steel-sale');

    const service = root.querySelector('[data-sz-service-addon-card]');
    const info = root.querySelector('.product__info-container') || root;
    if (service?.parentNode) service.parentNode.insertBefore(card, service);
    else info.append(card);

    card.hidden = false;
    card.classList.remove('sz-boot-only-steel-staging');
    card.dataset.szBootOnlyMounted = 'true';
  };

  const init = (scope = document) => {
    scope.querySelectorAll?.(CARD).forEach(mount);
    if (scope.matches?.(CARD)) mount(scope);
  };

  document.addEventListener('shopify:section:load', (event) => {
    window.requestAnimationFrame(() => init(event.target));
  });

  init();
  window.setTimeout(() => init(), 80);
})();
